import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable, Inject } from '@angular/core';
import { Observable, tap } from 'rxjs';
import { RevenueReport } from '../../../interfaces/reports/revenue-report';
import { REG_HUB_COMMON_CONFIG, RegHubCommonConfig } from '../../../reg-hub-common-config';

@Injectable({
  providedIn: 'root'
})
export class RevenueReportService {
  protected _baseLink: string;

  constructor(
    @Inject(REG_HUB_COMMON_CONFIG) private config: RegHubCommonConfig,
    private http: HttpClient) {
    this._baseLink = `${config.rootUrl}/Reports/Revenue`;
  }

  public getRevenueReport(filters: HttpParams): Observable<RevenueReport[]> {
    return this.http.get<RevenueReport[]>(`${this._baseLink}`, { params: filters });
  }
}
